/* Click-to-play video wall. Nothing downloads until the customer taps a tile. */
/* Each video-testimonials section includes this file, so two sections on one page
   run it twice; the guard stops the second run redeclaring the class. */
if (!customElements.get('video-testimonials')) {
class VideoTestimonials extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-vt-play]');
      if (btn) this.play(btn);
    });
    this.warm();
  }
  play(btn) {
    const media = btn.closest('[data-vt-media]');
    if (!media || media.dataset.vtLoaded === 'true') return;
    const tpl = media.querySelector('template');
    if (!tpl) return;
    media.dataset.vtLoaded = 'true';
    const frag = tpl.content.cloneNode(true);
    media.querySelectorAll('img, [data-vt-play], .vt__scrim').forEach((n) => n.remove());
    media.appendChild(frag);
    const v = media.querySelector('video');
    if (!v) return;
    // Start on the lighter rendition picked while the card scrolled into view
    // (see warm) instead of Shopify's master playlist, which lists 1080p first
    // — and iOS starts playback on the first-listed variant.
    const hls = v.querySelector('source[type="application/x-mpegURL"]');
    if (hls && media.dataset.vtVariant) { hls.src = media.dataset.vtVariant; v.load(); }
    v.play().catch(() => {});
  }

  /* When the section nears the viewport, fetch each card's HLS master playlist
     (a few KB) and remember the best variant no taller than 720px — 480px on
     data-saver or a slow connection. Shopify names renditions by height, so a
     vertical "1080p" clip is 606x1080 and "720p" is 404x720. Its media playlist
     is fetched too, so a tap goes straight to the first video segment. The whole
     section is observed, not each card: cards sit in a horizontal rail, and ones
     scrolled off to the side never count as intersecting until swiped to. */
  warm() {
    const cards = Array.from(this.querySelectorAll('[data-vt-media]'));
    if (!cards.length || !('IntersectionObserver' in window) || !window.fetch) return;
    const c = navigator.connection || {};
    const cap = (c.saveData || /(^|-)2g|3g/.test(c.effectiveType || '')) ? 480 : 720;
    const io = new IntersectionObserver((entries) => {
      if (!entries.some((e) => e.isIntersecting)) return;
      io.disconnect();
      cards.forEach((m) => this.pickVariant(m, cap));
    }, { rootMargin: '400px 0px' });
    io.observe(this);
  }

  async pickVariant(media, cap) {
    try {
      const tpl = media.querySelector('template');
      const src = tpl && tpl.content.querySelector('source[type="application/x-mpegURL"]');
      if (!src) return;
      const master = new URL(src.getAttribute('src'), location.href).href;
      const text = await (await fetch(master)).text();
      const lines = text.split(/\r?\n/);
      let best = null;
      lines.forEach((l, i) => {
        if (!l.startsWith('#EXT-X-STREAM-INF')) return;
        const r = /RESOLUTION=(\d+)x(\d+)/.exec(l);
        const uri = (lines[i + 1] || '').trim();
        if (!r || !uri) return;
        const h = +r[2];
        if (h <= cap && (!best || h > best.h)) best = { h, url: new URL(uri, master).href };
      });
      if (!best) return;
      media.dataset.vtVariant = best.url;
      fetch(best.url).catch(() => {});   // warm the media playlist
    } catch (e) { /* keep the master playlist — it still plays */ }
  }
}
customElements.define('video-testimonials', VideoTestimonials);
}
